var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23991 0V3.36M12.2 0V3.36M1 5.03999H14.44M7.72007 6.72V12.32M13.32 14H2.12C1.50313 14 1 13.4969 1 12.88V2.8C1 2.18313 1.50313 1.68 2.12 1.68H13.32C13.9369 1.68 14.44 2.18313 14.44 2.8V12.88C14.44 13.4969 13.9369 14 13.32 14Z",
    stroke: "#8698A5",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.3ba6afed87517b0d8ccecaa633a872cc.svg";
export { ForwardRef as ReactComponent };